import * as React from "react";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { NavigatorProps, ARROW_LINK_DIRECTION } from "../typings";
import { ArrowLink } from "./components/ArrowLink";

export const NavigatorChart = ({ monthRange, onChange, currentSlide, shouldShowNavigation }: NavigatorProps) => (
  <UitkLayoutFlex
    className="all-b-padding-four all-t-padding-three"
    justifyContent={shouldShowNavigation ? "space-between" : "center"}
  >
    {shouldShowNavigation && (
      <UitkLayoutFlexItem>
        <div>
          <ArrowLink direction={ARROW_LINK_DIRECTION.LEFT} onClick={onChange} disabled={!currentSlide} />
        </div>
      </UitkLayoutFlexItem>
    )}
    <UitkLayoutFlexItem className={`all-y-padding-two`}>
      <span>{monthRange}</span>
    </UitkLayoutFlexItem>
    {shouldShowNavigation && (
      <UitkLayoutFlexItem>
        <div>
          <ArrowLink direction={ARROW_LINK_DIRECTION.RIGHT} onClick={onChange} disabled={!!currentSlide} />
        </div>
      </UitkLayoutFlexItem>
    )}
  </UitkLayoutFlex>
);
